import './tab.component.scss';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const Tab = props => {
  const { tabList, changeTab } = props;
  const { t } = useTranslation();
  return (
    <>
      <div className="tab-container">
        <div className="tab-and-panel-container">
          <ul className="nav nav-tabs general-nav-tabs">
            {tabList &&
              tabList.map((tab, index) => {
                return (
                  <li
                    className={`nav-item ${!tab.isActive ? 'tab-item' : 'tab-active-item'}`}
                    key={index}
                    onClick={() => changeTab(tab)}
                  >
                    {t(tab.label)}
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default memo(Tab);
